<template>
    <b-container>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
           <b-row>
                <b-col md="6" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Agency Details</p>
                    <p></p>
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="ing1" horizontal
                            label="Working Status <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp1">
                            <b-form-select id="inp1"
                                :options="WorkStatus"
                                required size="sm"
                                v-model="form.WorkingStatus">
                        </b-form-select>  
                    </b-form-group>
                    <b-form-group id="ing11" horizontal
                            label="Nature Of Appointment <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp11">
                            <b-form-select id="inp11"
                                :options="AppointmentType"
                                required size="sm"
                                v-model="form.NatureofAppointment">
                        </b-form-select> 
                    </b-form-group>
                    <b-form-group id="ing2" horizontal
                            label="Name of the Agency<span style='color:red'>*</span>" label-size="sm"
                            label-for="inp2">
                        <b-form-input id="inp2"
                            type="text"
                            required size="sm"
                            v-model="form.AgencyName"
                            placeholder="Name of the Agency"></b-form-input>   
                    </b-form-group>
                    <b-form-group id="ing3" horizontal
                            label="Address of the Agency<span style='color:red'>*</span>" label-size="sm"
                            label-for="inp3">
                        <b-form-input id="inp3"
                            type="text"
                            v-model="form.AgencyAddress"
                            required size="sm"
                            placeholder="Address of the Agency"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing4" horizontal 
                             label-size="sm" label="Agency Contact No<span style='color:red'>*</span>">
                        <b-form-input id="inp4"
                            type="text"
                            v-model="form.AgencyContactNo"
                            required size="sm"
                            placeholder="Agency Contact No"></b-form-input>
                    </b-form-group>


                    </div>
                </b-col>
                <b-col  md="6" sm="12"  class="mt-2">
                    <p>
                        <span style="font-size: 17px;color:#2284ab;">Employer Details</span> 
                    </p>
                    
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
					         
                      <b-form-group id="ing7" horizontal
                              label="Name of the Principal Employer<span style='color:red'>*</span>" label-size="sm"
                              label-for="inp7">
                          <b-form-input id="inp7"
                              type="text" required
                              v-model="form.PrincipalEmployerName"
                              size="sm"
                              placeholder="Name of the Principal Employer"></b-form-input>    
                      </b-form-group>
                      <!-- <b-form-group id="ing8" horizontal
                              label="Employer Contact Person" label-size="sm"
                              label-for="inp8">
                          <b-form-input id="inp8"
                              type="text"
                              v-model="form.PrincipalContactName"
                              required size="sm"
                              placeholder="Principal Employer Address"></b-form-input>    
                      </b-form-group> -->
                      <b-form-group id="ing9" horizontal
                              label="Location of Work Place <span style='color:red'>*</span>" label-size="sm"
                              label-for="inp9">
                          <b-form-input id="inp9"
                              type="text"
                              v-model="form.WorkingLocation"
                              required size="sm"
                              placeholder="Location of Work Place"></b-form-input>    
                      </b-form-group>
                      <b-form-group id="ing10" horizontal
                              label="Principal Employer Contact No." label-size="sm"
                              label-for="inp10">
                          <b-form-input id="inp10"
                              type="text"
                              v-model="form.PrincipalEmployerContactNo"
                              required size="sm"
                              placeholder="Principal Employer Contact No."></b-form-input>    
                      </b-form-group>
					          
                      <b-form-group id="ing17" horizontal
                              label="Date of Joining <span style='color:red'>*</span>" label-size="sm"
                              label-for="inp17">
                          <date-picker v-model="StartDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>  
                      </b-form-group>
                      <b-form-group id="ing18" horizontal
                              label="Last date of Working <span style='color:red'>*</span>" label-size="sm"
                              label-for="inp18" v-if="form.WorkingStatus=='Past'">
                          <date-picker v-model="EndDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>
                      </b-form-group>
                    </div>
                </b-col>
            </b-row>
            
            <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
                <b-col md="4" sm="12" style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col  md="4" sm="12" style="text-align:right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>

        <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Employer Details</p>
                <b-row align-h="center">
                    <b-col>
                        <b-table show-empty head-variant="dark"
                                    stacked="md"
                                    bordered
                                    striped
                                    :items="experienceList"
                                    :fields="fields"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    style="font-size:12px"   
                        >
                        
                            <template slot="show_details" slot-scope="row">
                            <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                            <b-button size="sm" @click.stop="row.toggleDetails" variant="link" class="m-0">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}}
                            </b-button>
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button size="sm" @click.stop="editRecords(row.item, row.index, $event.target)" 
                                    class="mr-1 pt-0 pb-0" variant="link" v-b-tooltip.hover title="Edit Record"  v-if="!LockProfile">
                                    <i class="fa fa-edit" style="font-size:16px;color:blue"></i> 
                                </b-button>
                                <b-button size="sm" @click.stop="deleteRecords(row.item, row.index, $event.target)" 
                                    class="mr-1 pt-0 pb-0" variant="link" v-b-tooltip.hover title="Delete Record"  v-if="!LockProfile">
                                    <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                                </b-button>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <span>{{row.item.description}}</span>
                                </b-card>
                            </template>
                            </b-table>
                    </b-col>
                </b-row>
            </div>
            <b-modal id="modalConfirm" title="Are you sure?" size="sm">
              <pre>{{ modalInfo }}</pre>
              <div slot="modal-footer">
                  <b-button variant="warning" @click="modalConfirm" style= "margin-left:5px">Delete</b-button>
                  <b-button variant="secondary" @click="modalCancel" style= "margin-left:5px">Cancel</b-button>
              </div>
            </b-modal>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
export default {
  name: "FamilyDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      WorkStatus: ["Past", "Present"],
      AppointmentType: ["Direct Employer", "Through Agency"],
      StartDate:null,
      EndDate:null,
      form: {
        ExperienceID: "00000000-0000-0000-0000-000000000000",
        UserID: "",
        AgencyName: "",
        AgencyAddress: "",
        AgencyContactNo:"",
        WorkingLocation: "",
        StartDate: null,
        EndDate: null,
        PrincipalEmployerName: "",
        PrincipalContactName: "",
        PrincipalEmployerContactNo: "",
        NatureofAppointment: "",
        WorkingStatus: ""
      },
      experienceList: [],
      fields: [
        {
          key: "NatureofAppointment",
          label: "Appointment Nature",
          sortable: true
        },
        {
          key: "PrincipalEmployerName",
          label: "Employer Name",
          sortable: true
        },
        // {
        //   key: "PrincipalContactName",
        //   label: "Emp. Contact Person",
        //   sortable: true
        // },
        {
          key: "PrincipalEmployerContactNo",
          label: "Employer Contact No",
          sortable: true
        },
        { key: "AgencyName", label: "Agency Name", sortable: true },
        { key: "AgencyAddress", label: "Agency Address" },
        { key: "WorkingLocation", label: "Working Location" },

        { key: "StartDate", label: "Start Date", sortable: true },
        { key: "EndDate", label: "End Date", sortable: true },
        { key: "WorkingStatus", label: "Working Status", sortable: true },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      saved: false,
      selectedExperienceId: ""
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    }
  },

  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    convertDateFormatYMD(inDate){
      let dbDateTime = new Date(inDate);
      let formattedDate = dbDateTime.getFullYear() + "-" + (dbDateTime.getMonth()+1) + "-" + dbDateTime.getDate();
      return formattedDate;
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;

      var userinfo = this.$store.getters.loggedUser;
      this.form.UserID = userinfo.UserId;
      this.form.StartDate = this.convertDateFormatYMD(this.StartDate);
      this.form.EndDate = this.convertDateFormatYMD(this.EndDate);
      //let promise = apis.saveFamilyMember(this.form);

      let promise = apis.saveExperienceList(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.getEmpRecods();
            this.onReset();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.ExperienceID = "00000000-0000-0000-0000-000000000000";
      this.form.UserID = "";
      this.form.AgencyName = "";
      this.form.AgencyAddress = "";
      this.form.WorkingLocation = "";
      this.form.StartDate = null;
      this.form.EndDate = null;
      this.form.PrincipalEmployerName = "";
      this.form.PrincipalContactName = "";
      this.form.PrincipalEmployerContactNo = "";
      this.form.NatureofAppointment = "";
      this.form.WorkingStatus = "";
      this.form.AgencyContactNo="";
    },
    editRecords(item, index, target) {
      this.selectedExperienceId = item.ExperienceID;
      this.form.ExperienceID = item.ExperienceID
      this.form.AgencyName = item.AgencyName;
      this.form.AgencyAddress = item.AgencyAddress;
      this.form.WorkingLocation = item.WorkingLocation;
      this.StartDate = item.StartDate;
      this.EndDate = item.EndDate;
      this.form.PrincipalEmployerName = item.PrincipalEmployerName;
      this.form.PrincipalContactName = item.PrincipalContactName;
      this.form.PrincipalEmployerContactNo = item.PrincipalEmployerContactNo;
      this.form.NatureofAppointment =item.NatureofAppointment;
      this.form.WorkingStatus = item.WorkingStatus;
    },
    getEmpRecods() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadUserExperienceList(userinfo.UserId);

      promise
        .then(response => {
          if (response.status == 200) {
            this.experienceList = response.body;
            if(this.experienceList.length>0){
              this.$store.dispatch("setExperienceFlag", true); //Dsplay the Experience file Upload 
            } 
            // else {
            //   this.$store.dispatch("setExperienceFlag", false);
            // }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    deleteRecords(item, index, button) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.ExperienceID = item.ExperienceID;
      this.form.UserID = userinfo.UserId;

      let info = "You want to delete record for:" + "\n" + item.PrincipalEmployerName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      //let promise = apis.deleteRecords(this.form);
      let promise = apis.deleteExperienceList(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getEmpRecods();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    }
  },
  mounted() {
    this.getEmpRecods();
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/ExperienceNewGuard.vue